import { defineNuxtPlugin } from 'nuxt/app';
import { BCarousel, BCarouselSlide, BPagination } from 'bootstrap-vue-next';

export default defineNuxtPlugin(function (nuxtApp) {
  const vueApp = nuxtApp.vueApp;
  vueApp.component('BCarousel', BCarousel);
  vueApp.component('BCarouselSlide', BCarouselSlide);
  vueApp.component('BPagination', BPagination);
});
